// Generated by ReScript, PLEASE EDIT WITH CARE

import HeaderViewCmpTsx from "./HeaderViewCmp.tsx";

var make = HeaderViewCmpTsx;

export {
  make ,
}
/* make Not a pure module */
